import React, { useState } from 'react';
import { Navbar, Form, FormControl, Button, Nav, Dropdown, Image } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserCircle, faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import './TopNavBar.scss';
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from '@azure/msal-react';
import NotificationsDropdown from '../NotificationDropdown/NotificationDropdown';
import ConfirmationModal from '../ConfirmationModal/ConfirmationModal';
import { useNavigate } from 'react-router-dom';

const TopNavBar = ({title}) => {
    const { instance, inProgress } = useMsal();
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const navigate = useNavigate();
    let activeAccount;

    if (instance) {
        activeAccount = instance.getActiveAccount();
    }

    const handleLogoutRedirect = () => {
        instance.logoutRedirect();
    };

    const handleLogout = () => {
        setShowConfirmationModal(true);
    }

    return (
        <Navbar className="top-nav-bar w-100 justify-content-between">
            {/* <SearchBar /> */}
            <h4 className='m-0 p-0 screen-title'>{title}</h4>
            <AuthenticatedTemplate>
                <Nav className="ml-auto align-items-center">
                    <NotificationsDropdown />
                    <Button className='support-button text-light me-3 ms-5' variant='accent' size='md' onClick={() => navigate("/support")}>Support</Button>
                    {/* User details */}
                    {/* <Nav.Item className='me-3'>
                        <FontAwesomeIcon icon={faUserCircle} className="user-icon text-primary" />
                    </Nav.Item>
                    <Nav.Item className="mr-2 text-dark user-info">
                        <p className='fw-bold'>{activeAccount && activeAccount.name}</p>
                        <p className="small fw-normal text-secondary-emphasis">{activeAccount && activeAccount.username}</p>
                    </Nav.Item> */}
                    {/* User dropdown menu */}

                    {/* <Dropdown align="end">
                        <Dropdown.Toggle variant="transparent" id="dropdown-profile">
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <Dropdown.Item as="button" onClick={handleLogout}>
                                Sign out
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown> */}

                </Nav>
            </AuthenticatedTemplate>
            <UnauthenticatedTemplate>
                <Button variant="outline-primary" onClick={() => instance.loginRedirect()}>
                    Sign in
                </Button>
            </UnauthenticatedTemplate>
            <ConfirmationModal
                show={showConfirmationModal}
                onHide={() => setShowConfirmationModal(false)}
                onAcceptClick={() => handleLogoutRedirect()}
                onCancelClick={() => setShowConfirmationModal(false)}
                title='Signing out from your account'
                content="Are you sure that you want to log out?"
            />
        </Navbar>
    );
};

export default TopNavBar;
